import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getProductList, updateProductList } from '../actions/ProductListActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import ProductListForm from '../components/ProductListForm';

import Configuration from '../Config';

const validation = Configuration.Validations.productList;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditProductList extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getProductList(this.id));
    }

    handleSave = (values) => {
        this.props.dispatch(updateProductList(this.props.productList.id, values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/payment-types">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la liste produse
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16}>
                        <Link to={`/product-lists/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Lista produse - <strong>{this.props.productList.name}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <ProductListForm 
                            isEdit={true}
                            initialValues={this.props.productList}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.productLists.errors.type === 'validation' ? mapValidationErrors(state.productLists.errors.fields): [],
        productList: state.productLists.current
    }
}

export default connect(mapStateToProps)(EditProductList);